export function totalTableRowCount(totalCount, linesLimit) {
    return Math.ceil(totalCount / linesLimit)
}